import script from "./GroupsFormOrganism.vue?vue&type=script&setup=true&lang=ts"
export * from "./GroupsFormOrganism.vue?vue&type=script&setup=true&lang=ts"

import "./GroupsFormOrganism.vue?vue&type=style&index=0&id=0afeba48&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0afeba48"]])

export default __exports__